// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryReadResponseMetaQuery } from './HistoryReadResponseMetaQuery';
import {
    HistoryReadResponseMetaQueryFromJSON,
    HistoryReadResponseMetaQueryFromJSONTyped,
    HistoryReadResponseMetaQueryToJSON,
    HistoryReadResponseMetaQueryToJSONTyped,
} from './HistoryReadResponseMetaQuery';

/**
 * 
 * @export
 * @interface HistoryReadResponseMeta
 */
export interface HistoryReadResponseMeta {
    /**
     * REST path to the function
     */
    browsePath: string;
    /**
     * 
     */
    query: HistoryReadResponseMetaQuery;
}

/**
 * Check if a given object implements the HistoryReadResponseMeta interface.
 */
export function instanceOfHistoryReadResponseMeta(value: object): value is HistoryReadResponseMeta {
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function HistoryReadResponseMetaFromJSON(json: any): HistoryReadResponseMeta {
    return HistoryReadResponseMetaFromJSONTyped(json, false);
}

export function HistoryReadResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryReadResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'],
        'query': HistoryReadResponseMetaQueryFromJSON(json['query']),
    };
}

export function HistoryReadResponseMetaToJSON(json: any): HistoryReadResponseMeta {
    return HistoryReadResponseMetaToJSONTyped(json, false);
}

export function HistoryReadResponseMetaToJSONTyped(value?: HistoryReadResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'query': HistoryReadResponseMetaQueryToJSON(value['query']),
    };
}

